module.exports = __webpack_public_path__ + "static/img/user-bg.7c187400.png";